import React, { useContext } from 'react';
import { AuthContext } from '../Auth/AuthContext';
import { CircleLoader } from "../PageFillers/PageLoaders";

export default function Login() {
    const authService = useContext(AuthContext);
    authService.authorize();

    return <CircleLoader loadingText="Loading identity configuration..." />;
}